module.exports = __webpack_public_path__ + "img/missionaries13_2019_7-7-2021.35342f3e.jpg";